import React from 'react';
import BigTailoredRegion from './BigTailoredRegion';


const CreateBigMarket = () => {
  return (
      <BigTailoredRegion />
  );
};

export default CreateBigMarket;
